import { BrowserModule } from '@angular/platform-browser';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { CustomMaterialModule } from './custom-material/custom-material.module';
import { AppRoutingModule } from './app-routing.module';
import { LoggerModule } from 'ngx-logger';
import { environment } from '../environments/environment';

import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';

import localeSk from '@angular/common/locales/sk';
import { LOCALE_ID } from '@angular/core';
import { KeycloakAuthorizationService } from './auth/keycloak.authorization.service';
import { AuthTokenInterceptor } from './core/interceptors/http.interceptor';

registerLocaleData(localeSk);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    CustomMaterialModule.forRoot(),
    AppRoutingModule,
    LoggerModule.forRoot({
      // serverLoggingUrl: `http://my-api/logs`,
      level: environment.logLevel,
      serverLogLevel: environment.serverLogLevel
    }),
    
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    provideHttpClient(),
    provideAppInitializer(async () => {
      const kc = inject(KeycloakAuthorizationService);
      // ← Return the Promise directly
      try {
        return await kc
          .init(
            {
              url: environment.keycloak.authority,
              realm: environment.keycloak.realm,
              clientId: environment.keycloak.clientId
            },
            {
              onLoad: 'check-sso',
              silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html'
              // onLoad: 'login-required',
              // redirectUri: window.location.origin + '/',
              // pkceMethod: 'S256'
            }
          );
      } catch {
        // only redirect once if init failed
        // kc.login();
        console.warn('Keycloak init failed or not authenticated silently');
      }
    }),
    KeycloakAuthorizationService,
    { 
      provide: LOCALE_ID, 
      useValue: 'sk'
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// Factory function for loading translations
export function HttpLoaderFactory(http: HttpClient) {
  // TODO: Pre prod treba vymysliet sposob ako verziovat .json
  // pre development to je len ako 'getTime()'
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?v=${new Date().getTime()}`); 
}